import { Box, Paper } from '@mui/material';
import React from 'react';
/**
 * @deprecated created to help with old component migration.
 */
export const AppPaper = (props) => {
    return (React.createElement(Box, { sx: {
            m: {
                md: 2,
            },
        } },
        React.createElement(Paper, { sx: {
                width: props.contentWidth ? getContentWidth(props.contentWidth) : undefined,
                padding: (theme) => (props.contentPadding ? theme.spacing(props.contentPadding) : 0),
                margin: props.contentWidth ? 'auto' : undefined,
                borderRadius: {
                    xs: 0,
                    md: (theme) => theme.shape.borderRadius,
                },
                boxShadow: {
                    xs: 0,
                    md: 4,
                },
            }, elevation: 4 }, props.children)));
};
function getContentWidth(contentWidth) {
    return typeof contentWidth === 'string' ? `min(100vw, ${contentWidth})` : `min(100vw, ${contentWidth}px)`;
}
